import React, { useEffect, useState } from 'react';
import { useSearchParams, Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { CheckCircle, XCircle, Loader2 } from 'lucide-react';

const VerifyEmail = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState('loading');
  const [error, setError] = useState('');
  const { login: setAuthData } = useAuth();
  const navigate = useNavigate();
  const API = process.env.REACT_APP_BACKEND_URL;

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setStatus('error');
      setError('Overovaci odkaz je neplatny');
      return;
    }

    const verify = async () => {
      try {
        const response = await fetch(`${API}/api/auth/verify-email?token=${token}`);
        const data = await response.json();

        if (response.ok) {
          setStatus('success');
          // Auto-login after verification
          if (data.access_token) {
            localStorage.setItem('sunify_token', data.access_token);
            localStorage.setItem('sunify_user', JSON.stringify(data.user));
            setTimeout(() => { window.location.href = '/'; }, 2500);
          }
        } else {
          setStatus('error');
          setError(data.detail || 'Overenie zlyhalo');
        }
      } catch (err) {
        setStatus('error');
        setError('Chyba pripojenia k serveru');
      }
    };

    verify();
  }, [searchParams, API, navigate]);

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center py-12 px-4">
      <div className="max-w-md w-full">
        <div className="bg-white rounded-lg shadow-md p-8 text-center">
          {status === 'loading' && (
            <>
              <Loader2 className="h-16 w-16 text-orange-500 animate-spin mx-auto mb-4" />
              <h2 className="text-2xl font-bold mb-2">Overujem email...</h2>
              <p className="text-gray-600">Prosim pockajte</p>
            </>
          )}

          {status === 'success' && (
            <>
              <div className="mx-auto w-16 h-16 bg-green-500 rounded-full flex items-center justify-center mb-4">
                <CheckCircle className="h-8 w-8 text-white" />
              </div>
              <h2 className="text-2xl font-bold mb-2 text-green-700" data-testid="verify-success">
                Email overeny!
              </h2>
              <p className="text-gray-600 mb-6">
                Vas ucet bol uspesne aktivovany. O chvilu budete presmerovany na hlavnu stranku.
              </p>
              <Link
                to="/"
                className="inline-block px-6 py-3 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition"
              >
                Prejst na hlavnu stranku
              </Link>
            </>
          )}

          {status === 'error' && (
            <>
              <div className="mx-auto w-16 h-16 bg-red-500 rounded-full flex items-center justify-center mb-4">
                <XCircle className="h-8 w-8 text-white" />
              </div>
              <h2 className="text-2xl font-bold mb-2 text-red-700" data-testid="verify-error">
                Overenie zlyhalo
              </h2>
              <p className="text-gray-600 mb-6">{error}</p>
              <Link
                to="/register"
                className="inline-block px-6 py-3 bg-orange-500 text-white rounded-lg font-semibold hover:bg-orange-600 transition"
              >
                Registrovat sa znova
              </Link>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default VerifyEmail;
